import QcIcon from '../../../../assets/icons/qc/logo.svg';
import { Icon, Image, Stack, Text, styled } from '@qcx/ui';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { useNewsStore } from '../../news.store';

export const Head = () => {
  const isSidebarOpen = useNewsStore(s => s.isSidebarOpen);
  const toggleSidebar = useNewsStore(s => s.toggleSidebar);

  return (
    <Stack
      css={{
        alignItems: 'center',
        py: '$1',
        '@lg': { pointerEvents: 'none', cursor: 'text' }
      }}
      gap="$4"
      onClick={() => toggleSidebar()}
    >
      <StyledIcon
        width={24}
        height={24}
        alt="Logo Qconcursos"
        src={QcIcon}
        noAspectRatio
        priority
      />
      <Text css={{ color: '$neutral800' }} variant="md" weight="semibold">
        Conteúdo Qconcursos
      </Text>
      <Icon
        css={{
          marginLeft: 'auto',
          marginRight: 0,
          color: '$secondary500',
          d: 'flex',
          '@lg': {
            d: 'none'
          }
        }}
        icon={isSidebarOpen ? faChevronDown : faChevronUp}
        size="lg"
      />
    </Stack>
  );
};

const StyledIcon = styled(Image, {
  width: 32,
  '& img': {
    h: 24,
    objectFit: 'contain'
  }
});
